const mapperPdiCheckinToApi = (form) => {
    const { comments, satisfaction, currentValue, status, evidence } = form

    return {
        comments,
        satisfaction,
        current_value: currentValue,
        status,
        evidence,
    }
}

export { mapperPdiCheckinToApi }
